module.exports = __webpack_public_path__ + "img/frame (269).822afdeb.jpg";